// import { FaExternalLinkAlt } from 'react-icons/fa';

// const BlogCard = ({ blog }) => {
//   return (
//     <div className='bg-[#111111] p-6 rounded-lg shadow-lg max-w-sm mx-auto transition-transform transform hover:scale-105 z-0'>
//       {/* Thumbnail */}
//       <img
//         src={blog.thumbnail}
//         alt={blog.title}
//         className='w-full h-40 object-cover rounded-md mb-4'
//       />

//       {/* Title */}
//       <h3 className='text-2xl font-semibold text-white mb-4'>{blog.title}</h3>

//       {/* Link */}
//       <a
//         href={blog.link}
//         target='_blank'
//         rel='noopener noreferrer'
//         className='flex items-center gap-2 text-blue-400 font-medium hover:underline'
//       >
//         <span>Read Article</span>
//         <FaExternalLinkAlt />
//       </a>
//     </div>
//   );
// };

// export default BlogCard;

import { FaExternalLinkAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';

const BlogCard = ({ blog }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
    hover: {
      scale: 1.05,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 20,
      },
    },
  };

  return (
    <motion.div
      className='bg-[#111111] p-6 rounded-lg shadow-lg max-w-sm mx-auto z-0'
      variants={cardVariants}
      initial='hidden'
      animate='visible'
      whileHover='hover'
    >
      {/* Thumbnail */}
      <motion.img
        src={blog.thumbnail}
        alt={blog.title}
        className='w-full h-40 object-cover rounded-md mb-4'
        whileHover={{ scale: 1.02 }}
        transition={{ duration: 0.3 }}
      />

      {/* Title */}
      <h3 className='text-2xl font-semibold text-white mb-4'>{blog.title}</h3>

      {/* Link */}
      <motion.a
        href={blog.link}
        target='_blank'
        rel='noopener noreferrer'
        className='flex items-center gap-2 text-blue-400 font-medium hover:underline'
        whileHover={{ x: 5 }}
        transition={{ type: 'spring', stiffness: 200 }}
      >
        <span>Read Article</span>
        <FaExternalLinkAlt />
      </motion.a>
    </motion.div>
  );
};

export default BlogCard;
